export default function copy(value) {
  if (!navigator.clipboard) {
    console.log('no nav available, can\'t copy: ' + value)
    return
  }
  navigator.clipboard.writeText(value)
}
